/**
 * @voltxampere/ui — N-channel MOSFET (NMOS) · enhancement mode
 *
 * Heavy body line at x=10 (the channel "drain-source bar"). Gate
 * lead enters from the left to x=10. The drain stub (x=14, y=5-10)
 * and source stub (x=14, y=16-21) flank a dashed centre indicating
 * the enhancement-mode channel break.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const nmos = {
    id: "nmos",
    nameTr: "NMOS",
    nameEn: "N-MOSFET",
    shortcut: "M",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "G", polarity: "in" },
        { x: 32, y: 3, label: "D", polarity: "in" },
        { x: 32, y: 23, label: "S", polarity: "out" },
    ],
    defaultLabel: "M",
    renderSVG: () => [
        `<line x1="10" y1="5" x2="10" y2="21" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="14" y1="5" x2="14" y2="10" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="14" y1="16" x2="14" y2="21" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="14" y1="10" x2="14" y2="16" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}" stroke-dasharray="1.5,1.5"/>`,
        `<line x1="0" y1="13" x2="10" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="14" y1="8" x2="26" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="26" y1="3" x2="32" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="14" y1="18" x2="26" y2="23" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="26" y1="23" x2="32" y2="23" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=nmos.js.map